/*
 * Invoice + gift options: syncs the "invoice" and "gift" cart attributes via
 * the Cart AJAX API.
 *
 * 納品書 delivery (cart attribute `invoice`) is expressed with two mutually
 * exclusive checkboxes; the default (neither checked) is paperless email:
 *   紙を同梱  (.js-invoice-enclose) -> invoice = 'true'
 *   不要      (.js-invoice-none)    -> invoice = 'false'
 *   neither                          -> invoice = 'email'  (ペーパーレス標準)
 *
 * ギフト設定 (cart attribute `gift`) is an independent checkbox:
 *   .js-gift-toggle -> gift = 'true' | 'false'  (hides amounts on the enclosed doc)
 *
 * Unchecked checkboxes are not submitted with the form, so state is written on
 * every change with fetch('/cart/update.js') — the same pattern as
 * receipt-option.js. Cart page and cart drawer are kept in sync by class.
 *
 * A customer who is happy with the displayed default never fires a `change`
 * event, so without more the cart attribute is simply never set and the
 * resulting order has no `invoice`/`gift` key at all. To make every order
 * carry an explicit value, submitDefaultsOnce() posts the currently-displayed
 * default a single time on page load, but only when the raw cart attribute is
 * unset (data-invoice-unset/-gift-unset, rendered from the Liquid side without
 * the `| default` fallback) — once a value exists (from this or from a real
 * choice), it is never re-posted.
 *
 * Uses document-level event delegation with a global guard so it survives
 * cart drawer re-renders.
 */
(function () {
  if (window.__invoiceOptionBound) return;
  window.__invoiceOptionBound = true;

  function post(attributes) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    });
  }

  function setChecked(selector, checked) {
    document.querySelectorAll(selector).forEach((cb) => { cb.checked = checked; });
  }

  function submitDefaultsOnce() {
    if (document.querySelector('[data-invoice-unset="true"]')) {
      const enclose = document.querySelector('.js-invoice-enclose');
      const none = document.querySelector('.js-invoice-none');
      const value = enclose && enclose.checked ? 'true' : (none && none.checked ? 'false' : 'email');
      post({ invoice: value });
    }
    if (document.querySelector('[data-gift-unset="true"]')) {
      const gift = document.querySelector('.js-gift-toggle');
      post({ gift: gift && gift.checked ? 'true' : 'false' });
    }
  }
  submitDefaultsOnce();

  document.addEventListener('change', (e) => {
    const enclose = e.target.closest('.js-invoice-enclose');
    if (enclose) {
      const on = enclose.checked;
      setChecked('.js-invoice-enclose', on);
      if (on) setChecked('.js-invoice-none', false); // mutually exclusive
      post({ invoice: on ? 'true' : 'email' });
      return;
    }

    const none = e.target.closest('.js-invoice-none');
    if (none) {
      const on = none.checked;
      setChecked('.js-invoice-none', on);
      if (on) setChecked('.js-invoice-enclose', false); // mutually exclusive
      post({ invoice: on ? 'false' : 'email' });
      return;
    }

    const gift = e.target.closest('.js-gift-toggle');
    if (gift) {
      const on = gift.checked;
      setChecked('.js-gift-toggle', on);
      post({ gift: on ? 'true' : 'false' });
    }
  });
})();
